<template>
  <div class="order">
    <h2 class="tit-30 fw700">我的订单</h2>
    <div class="list">
      <ul>
        <li v-for="item in orderlist" :key="item.id">
          <div class="top flex-sbc">
            <div class="topleft flex-c tit-14 cor-666">
              <div class="danhao mr-20">订单号：{{ item.dingdanhao }}</div>
              <div class="time">{{ item.xiadanshijian }}</div>
            </div>
            <div class="topRight tit-14 cor-666">
              <div class="state">
                共{{ item.shangpinzongshu }}件商品合计:&nbsp;<span
                  class="cor-000 fw700"
                >
                  ¥{{ item.zongjia }}
                </span>
              </div>
            </div>
          </div>
          <div class="bom flex-sbc" style="padding: 0.2rem;">
            <div class="con flex-sbc" v-for="(s, i) in item.shangpin">
              <div class="conle flex-c">
                <div class="imgBox flex-cc">
                  <el-image :src="s.tu" fit="contain"></el-image>
                </div>
                <div class="info">
                  <div class="name fw700">{{ s.ming }}</div>
                  <div class="num">x{{ s.shuliang }}</div>
                </div>
              </div>
            </div>

            <div class="contorls">
              <div class="conre">
                <div
                  class="state flex-c"
                  style="justify-content: end;"
                  v-if="
                    item.zhuangtai == 0 &&
                      item.daojishi > 0 &&
                      item.zfstatus == 0
                  "
                >
                  <div class="icBox flex-cc mr-10">
                    <svg
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      width="16"
                      height="16"
                    >
                      <path
                        d="M521.142857 576h242.285714a36.571429 36.571429 0 0 1 0 73.142857H484.571429a36.571429 36.571429 0 0 1-36.278858-41.142857 36.937143 36.937143 0 0 1-0.292571-4.571429V228.571429a36.571429 36.571429 0 0 1 73.142857 0v347.428571zM512 1024C229.229714 1024 0 794.770286 0 512S229.229714 0 512 0s512 229.229714 512 512-229.229714 512-512 512z m0-73.142857c242.358857 0 438.857143-196.498286 438.857143-438.857143S754.358857 73.142857 512 73.142857 73.142857 269.641143 73.142857 512s196.498286 438.857143 438.857143 438.857143z"
                        fill="#EC0000"
                      ></path>
                    </svg>
                  </div>
                  <span class="tit-14">
                    {{ formatCountdown(item) }}
                  </span>
                </div>
              </div>
              <div
                class="btnBox flex-c mt-30 mb-20 "
                style="justify-content: end;"
              >
                <div class="btn btn1">{{ item.zhuangtai_wenzi }}</div>
                <div
                  class="btn btn2"
                  @click="quxiao(item)"
                  v-if="item.zhuangtai == 0"
                >
                  取消订单
                </div>
                <div
                  class="btn btn3"
                  @click="$router.push('/user/orderDetails/' + item.id)"
                >
                  查看详情
                </div>
                <div
                  class="btn btn4"
                  v-if="item.zhuangtai == 0 && item.zfstatus == 0"
                >
                  立即支付
                </div>
                <div class="btn btn5" v-if="item.zhuangtai == 10">交易成功</div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- <el-dialog
	  title="提示"  :visible.sync="dialogVisible"  width="30%">
	  <span>是否确认取消订单</span>
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="dialogVisible = false">取 消</el-button>
	    <el-button type="primary" >确 定</el-button>
	  </span>
	</el-dialog> -->
  </div>
</template>
<script>
let that;
export default {
  name: "OrderIndex",
  data() {
    return {
      orderlist: [],
      countdownTimer: null,
      dialogVisible: false,
      qshu: {},
    };
  },
  created() {
    // this.initCountdown();
    this.CSH();
    this.startGlobalTimer();
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    CSH() {
      that = this;
      //   console.log(9999);
      that.$post("m=limitao&k=dingdan", { ye: 1, jitiao: 10 }, function(shu) {
        if (shu.shi == 1) {
          that.orderlist = shu.shu.lie.map((order) => {
            return {
              ...order,
              // 计算到期时间戳（当前时间 + 剩余秒数）
              startTime: Date.now(),
            };
          });
        }
      });
    },
    quxiao(e) {
      // that.dialogVisible=true
      that
        .$confirm("确定取消订单吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          // 这里可补充实际接口请求，示例仅提示
          that.$post(
            "m=limitao&k=dingdan&c=quxiao",
            { dingdanid: e.id },
            function(shu) {
              if (shu.shi == 1) {
                that.CSH();
                that.dialogVisible = false;
                that.$message({
                  type: "success",
                  message: "订单取消成功!",
                });
              }
            },
          );
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消操作",
          });
        });
      // that.qshu=e
    },
    // querenquxiao(){
    // 	that.$post('m=limitao&k=dingdan&c=quxiao',{dingdanid: that.qshu.id},function(shu){
    // 		if(shu.shi==1){
    // 			that.CSH();
    // 			that.dialogVisible=false
    // 		}
    // 	});
    // },
    startGlobalTimer() {
      that = this;
      if (that.countdownTimer) {
        clearInterval(that.countdownTimer);
      }
      that.countdownTimer = setInterval(() => {
        that.updateAllCountdowns();
      }, 1000);
    },
    updateAllCountdowns() {
      that = this;
      const now = Date.now();
      let allExpired = true; // 初始化为“所有订单已过期”
      that.orderlist = that.orderlist.map((order) => {
        if (order.zhuangtai != 0) {
          return order;
        } else {
          // 存在待付款订单，说明未全部过期
          allExpired = false;
          const elapsedSeconds = Math.floor((now - order.startTime) / 1000);
          const remainingSeconds = Math.max(0, order.daojishi - elapsedSeconds);

          if (remainingSeconds === 0 && order.zfstatus == 0) {
            // 倒计时结束：调用 CSH 更新后台数据
            return {
              ...order,
              zhuangtai: 5,
              zhuangtai_wenzi: "已过期",
            };
          } else {
            // 倒计时未结束，返回剩余时间
            return {
              ...order,
              remainingSeconds: remainingSeconds,
            };
          }
        }
        // 非待付款订单，保持原状态
      });
      console.log(allExpired);
      if (allExpired) {
        clearInterval(that.countdownTimer);
        setTimeout(function() {
          that.CSH();
        }, 1000);
      }
    },
    formatCountdown(order) {
      if (order.daojishi == 0) return "00时00分00秒";
      const now = Date.now();
      const elapsedSeconds = Math.floor((now - order.startTime) / 1000);
      const remainingSeconds = Math.max(0, order.daojishi - elapsedSeconds);

      const hours = Math.floor(remainingSeconds / 3600)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((remainingSeconds % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (remainingSeconds % 60).toString().padStart(2, "0");
      return `${hours}时${minutes}分${seconds}秒`;
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  .list {
    padding-top: 0.2rem;

    li {
      border: 1px solid #e5e5e5;
      margin-top: 0.25rem;

      .top {
        padding: 0.1rem 0.2rem;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e5e5e5;
      }

      .con {
        // padding: 0.2rem;
        align-items: flex-end;

        .conle {
          .imgBox {
            width: 1rem;
            height: 1rem;
            margin-right: 0.5rem;

            .el-image {
              max-width: 100%;
              height: 100%;
            }
          }

          .info {
            .num {
              margin-top: 0.2rem;
              color: #9f9f9f;
            }
          }
        }

        .conre {
          .state {
            justify-content: flex-end;
          }
        }
      }

      .btnBox {
        justify-content: flex-end;

        .btn {
          margin-left: 0.1rem;
          background: rgba(225, 225, 225, 0.47);
          border-radius: 100px;
          font-size: var(--font14);
          color: #646464;
          padding: 5px 12px;
          cursor: pointer;

          &:hover {
            background: rgba(225, 225, 225, 0.8);
          }

          &.btn1 {
            color: #e60000;
            background: none;
            cursor: default;
          }

          &.btn4 {
            color: #ff0000;
            background: none;
            border: 1px solid #ff0000;

            &:hover {
              color: #fff;
              background: #ff0000;
            }
          }

          &.btn5 {
            cursor: default;
            opacity: 0.47;
            background: none;
            border: 1px solid #c0c0c0;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .order {
    .list {
      li {
        .top {
          flex-wrap: wrap;

          .topleft {
            flex-wrap: wrap;
          }

          .topRight {
            width: 100%;
            margin-top: 0.1rem;
          }
        }

        .bom {
          flex-wrap: wrap;

          .con {
            width: 100%;
          }

          .contorls {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
